define("powergen/models/static-part",
  [],
  function() {
    "use strict";
    var StaticPart;

    StaticPart = DS.Model.extend({
      part: DS.belongsTo('part'),
      position: DS.attr('point'),
      size: DS.attr('size')
    });


    return StaticPart;
  });